import { CSSProperties } from 'react';

const WINDOW_WIDTH = 500;
const WINDOW_HEIGHT = 500;

export const containerStyle: CSSProperties = {
  position: 'absolute',
  top: 22,
  right: 6,
  touchAction: 'none',
  zIndex: 10,
  width: WINDOW_WIDTH,
  height: WINDOW_HEIGHT,
};

export const handleStyle: CSSProperties = {
  cursor: 'grab',
  background: '#222',
  color: '#ccc',
  padding: '6px 10px',
  borderTopLeftRadius: 6,
  borderTopRightRadius: 6,
  userSelect: 'none',
  width: '100px',
  textAlign: 'center',
  top: -18,
  left: 150,
  position: 'absolute',
};
